export const APP_DIR = 'reports'
